<nav class="navbar navbar-expand-lg header_bg" *ngIf="isLoggIn">
    <a routerLink="/dashboard" class="navbar-brand pl-lg-4 mr-auto"><img src="assets/images/inner_lgo.png"></a>
    <div class="mr-2">
        <a routerLink="/user-profile-page"><img class="proImg" style="margin-top: -5px;" src="{{userprofile}}{{userLogo}}" onError="this.src='assets/images/default-img.jpg'"></a> &nbsp; <span style="color:white;font-weight: bold">{{loginName}}</span>&nbsp;
        <a href="javascript:void(0);" (click)="logOut()"><img src="assets/images/logout.png" style="height: 25px;"></a>
    </div>
</nav>